// TypeAheadDropDown.js
// import './TypeAheadDropDown.css';
/** @jsx jsx */
import { jsx } from '@emotion/core';
import Axios from 'axios';
import React from 'react';
import { SOLUTIONS_TEMPLATE_IDS } from '../../../../utils/constants';
import { Input } from '../../../ui/Form';
import { Icon } from '../../../ui/Icon';
import * as styles from './index.styles';
import get from 'lodash/get';
import Downshift from 'downshift';
import HighlightedText from '../../../ui/HighlightedText';

class AutoInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestions: [],
      text: props.value || '',
      showAllSuggestion: false,
      showSuggestions: true,
    };

    this.hideSuggestion = this.hideSuggestion.bind(this);
  }

  onTextChange = e => {
    const value = e.target.value;
    this.props.fetchSuggestions(value);

    this.setState(() => ({
      // suggestions,
      text: value,
      showSuggestions: true,
    }));
  };

  suggestionSelected = value => {
    this.setState(() => ({
      text: value.value,
      // suggestions: [],
    }));

    const { inputName, inputHiddenName, setFieldValue, onSelect } = this.props;
    setFieldValue(inputName, value.value);
    setFieldValue(inputHiddenName, value.ItemId);
    onSelect(value);
  };

  isLocationSolution = id =>
    id.split('-')[0] === SOLUTIONS_TEMPLATE_IDS.LOCATION;

  getIconName = templateId => {
    let iconName = 'pin-lines';

    if (this.isLocationSolution(templateId)) {
      iconName = 'office-space';
    }

    return iconName;
  };

  viewAllSuggestion = () => {
    this.setState({ showAllSuggestion: true });
  };

  renderSuggestions = (getMenuProps, getItemProps, highlightedIndex) => {
    const { suggestions } = this.props;
    const { showAllSuggestion } = this.state;
    if (suggestions.length === 0) {
      return null;
    }

    let showedItemCount = 0;
    return (
      <ul css={styles.suggestionList} {...getMenuProps()}>
        {suggestions.map((item, index) => {
          if (item.isGroupTitle) {
            return (
              <li
                key={`suggesion-${index}`}
                aria-hidden="true"
                className="group-title"
              >
                <span>{item.Name}</span>
              </li>
            );
          }
          if (item.isViewAll) {
            let viewAllclassName = 'view-all-item ';
            if (showAllSuggestion) {
              viewAllclassName = 'hide-item';
            }
            return (
              <li
                key={`suggesion-${index}`}
                onClick={this.viewAllSuggestion}
                aria-hidden="true"
                className={viewAllclassName}
              >
                <span>{item.Name}</span>
              </li>
            );
          }
          if (item.value == '') {
            return (
              <li
                key={`suggesion-${index}`}
                onClick={this.viewAllSuggestion}
                aria-hidden="true"
                className="no-data-found"
              >
                <span>{item.Name}</span>
              </li>
            );
          }
          const isHidden =
            showedItemCount > 4 && showAllSuggestion === false
              ? 'hide-item'
              : '';
          showedItemCount++;
          return (
            <li
              key={`suggesion-${index}`}
              onClick={() => this.suggestionSelected(item)}
              aria-hidden="true"
              className={isHidden}
              css={[
                highlightedIndex === index &&
                  styles.highlightedSearchResultItemCss,
              ]}
              {...getItemProps({ item: item, index })}
            >
              <span>
                <Icon name={this.getIconName(get(item, 'TemplateId', ''))} />
              </span>
              <span>
                <HighlightedText
                  // textCss={[
                  //   searchResultTextCss,
                  //   isDarkTheme && darkSearchResultTextCss,
                  // ]}
                  matchCss={styles.darkSearchResultTextMatchCss}
                  text={item.Name}
                  highlight={this.state.text}
                />
                {/* {item.Name} */}
              </span>
            </li>
          );
        })}
      </ul>
    );
  };

  onDropdownItemSelect = item => {
    this.suggestionSelected(item);
  };

  hideSuggestion = () => {
    this.setState({ showSuggestions: false });
  };
  showSuggestion = () => {
    this.setState({ showSuggestions: true });
  };

  render() {
    const { showSuggestions } = this.state;
    const { inputName, inputPlaceHolder, errors, touched, value } = this.props;
    // console.log('** text >> ', text, this.props);
    return (
      <Downshift
        onChange={this.onDropdownItemSelect}
        itemToString={item => get(item, 'Name', '')}
      >
        {({
          getRootProps,
          getMenuProps,
          getItemProps,
          highlightedIndex,
          getInputProps,
          isOpen,
        }) => {
          const { onBlur, ...restInputProps } = getInputProps({
            onChange: this.onTextChange,
            value: value,
            id: inputName,
          });
          return (
            <div
              aria-hidden="true"
              className="TypeAheadDropDown"
              css={[styles.TypeAheadDropDown]}
              onMouseLeave={this.hideSuggestion}
              onMouseEnter={this.showSuggestion}
              {...getRootProps({})}
            >
              <Input
                icon="icon-search"
                autocomplete="off"
                customContainerCss={styles.inputcontainer}
                className="typeHeadeInput-holder"
                id={inputName}
                placeholder={inputPlaceHolder}
                // onChange={this.onTextChange}
                defaultValue={value}
                value={value}
                onBlur={onBlur}
                error={
                  errors && errors[inputName] && touched && touched[inputName]
                }
                errorMessage={errors && errors[inputName]}
                inputProps={restInputProps}
              />

              {showSuggestions &&
                this.renderSuggestions(
                  getMenuProps,
                  getItemProps,
                  highlightedIndex,
                )}
            </div>
          );
        }}
      </Downshift>
    );
  }
}

AutoInput.displayName = 'BookVisit/AutoInput';

export default AutoInput;
